import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    DeleteLifecycleConnection,
    setLifecycleConnectionConfirmDelete,
    setLifecycleConnectionActive,
    setLifecycleModelReload,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDeleteConnection = () => {
    const connectionToDelete = useSelector((state: StoreType) => state.lifecycle.model.confirmDeleteConnection)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setLifecycleConnectionConfirmDelete(null))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        DeleteLifecycleConnection(connectionToDelete.id).then(() => {
            setDeleteState(IDLE)
            dispatch(setLifecycleConnectionActive(null))
            dispatch(setLifecycleConnectionConfirmDelete(null))

            dispatch(setLifecycleModelReload(false))
            setTimeout(() => {
                dispatch(setLifecycleModelReload(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper
            show={connectionToDelete !== null}
            onClose={onCancel}
        >
            <Confirm>
                <ConfirmTitle>{lang.delete}</ConfirmTitle>
                <ConfirmDescription>{lang.deleteConnectionConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteConnection
